import { createUseStyles } from 'react-jss'
import Box from '@mui/material/Box'
import Grid from '../../images/grid.jpg'
import React, { useEffect, useState } from 'react'

const useStyles = createUseStyles({
  logo: {
    width: 120,
    margin: '1rem',
    userSelect: 'none',
    cursor: 'default'
  }
})

const bufferToBase64 = (buffer) =>
  btoa(new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), ''))

const Image = ({ img }) => {
  const classes = useStyles()
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (!img) {
      setSrc(null)
      return
    }
    if (typeof img === 'string') {
      setSrc(img)
      return
    }

    if (img.file) {
      if (img.file.type === 'file' && typeof img.file.data === 'string' && img.file.data.startsWith('blob:')) {
        setSrc(img.file.data)
        return
      }

      if (img.file.type === 'Buffer' && Array.isArray(img.file.data)) {
        setSrc('data:image/png;base64,' + bufferToBase64(img.file.data))
        return
      }
      if (img.file instanceof File) {
        const url = URL.createObjectURL(img.file)
        setSrc(url)
        return () => URL.revokeObjectURL(url)
      }
    }
  }, [img])

  return (
    <Box
      component='img'
      src={src || undefined}
      className={classes.logo}
      sx={{
        backgroundImage: `url(${Grid})`,
        backgroundSize: '120px auto',
        padding: 0
      }}
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
      alt='Dynamic content'
    />
  )
}

export default Image
